import React from "react";
import { List } from "../modules/ReceiptingLogic";

export function ReceiptingLogicListPage() {
  return <List />;
}
